import { createJimp } from "@jimp/core";
import { defaultFormats, defaultPlugins } from "jimp";
import webp from "@jimp/wasm-webp";

const Jimp = createJimp({
  formats: [...defaultFormats, webp],
  plugins: defaultPlugins,
});

const resizeImage = async ({ image, width, height }) => {
  try {
    const jimpImage = await Jimp.read(image);

    await jimpImage.resize({
      w: width,
      h: height,
      mode: "bicubicInterpolation",
    });

    let mimeType = jimpImage.mime;

    const options =
      mimeType === "image/jpeg" ||
      mimeType === "image/webp"
        ? { quality: 100 }
        : {};

    return await jimpImage.getBase64(mimeType, options);
  } catch (error) {
    console.info('Unsupported image format, returning original image.', error);

    return image;
  }
};

export default resizeImage;
